<div class="panel" #panelElement [@slideAnimation]="panelState" (clickOutside)="hidePanel()"
     [exclude]="'.panels-sidebar'" [excludeBeforeClick]="true">
  <div class="content charts">
    <app-panel-charts [panelCharts]="panel?.chart" [columns]="panel?.columns"></app-panel-charts>
  </div>
</div>
